import { Box, Typography } from "@material-ui/core";
import NoDataFound from "Components/widgets/NoDataFound";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { checkinSRSDetailsState } from "Recoil/Targets/atom";
import { KENDO_DATE_FORMAT } from "src/constants";
import { checkArrayLength } from "src/utils";
import GridView from "./GridView";
import { useStyles } from "./styles";
import NoRespond from "Assets/images/empty-state/no-respond-found.svg";

const FeedbackGrid = ({ skillRatee }) => {
  const classes = useStyles();
  const SRSDetailsValue = useRecoilValue(checkinSRSDetailsState);
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
    setGridData(
      formatData(
        get(SRSDetailsValue, "ratingResponse.groupByQuestionsComments", [])
      )
    );
  }, [get(SRSDetailsValue, "ratingResponse")]);

  const formatData = comments =>
    comments
      .map(res => {
        return {
          rater: `${res?.rater?.firstName} ${res?.rater?.lastName}`,
          comments: res?.comment,
          completedOn: res?.commentedDate
            ? moment(res?.commentedDate).format(KENDO_DATE_FORMAT)
            : moment().format(KENDO_DATE_FORMAT)
        };
      })
      .sort((a, b) => a.rater - b.rater);
  return (
    <Box mt={3} className={`${classes.feedbackGrid}`}>
      <Box px={2} pt={2}>
        <Typography variant="subtitle" className="font-semibold font-16">
          Feedback for {skillRatee?.firstName} {skillRatee?.lastName}
        </Typography>
      </Box>
      <Box mt={2}>
        {checkArrayLength(gridData) ? (
          <GridView data={gridData} />
        ) : (
          <NoDataFound noDataCustomImg={NoRespond} nodataText="No response found" />
        )}
      </Box>
    </Box>
  );
};

export default FeedbackGrid;
